// PERSONA FRAGRANCE INTELLIGENCE — Phase 2.3 keys (Membership configuring)
export const P23 = {
  en: {
    membership_eyebrow: "MEMBERSHIP",
    membership_title: "Membership access is currently being configured.",
    membership_body:
      "Membership will provide access to the PERSONA fragrance intelligence ecosystem, including PERSONA AI PERFUMER and IPTECHS Academy.",
    membership_benefit_ai: "PERSONA AI PERFUMER",
    membership_benefit_academy: "IPTECHS ACADEMY",
    membership_benefit_profile: "AI Fragrance Profile",
    membership_benefit_history: "AI Consultation History",
    membership_status_member: "Member",
  },
  id: {
    membership_eyebrow: "KEANGGOTAAN",
    membership_title: "Akses keanggotaan sedang dikonfigurasi.",
    membership_body:
      "Keanggotaan akan memberikan akses ke ekosistem intelijen wewangian PERSONA, termasuk PERSONA AI PERFUMER dan IPTECHS Academy.",
    membership_benefit_ai: "PERSONA AI PERFUMER",
    membership_benefit_academy: "IPTECHS ACADEMY",
    membership_benefit_profile: "AI Fragrance Profile",
    membership_benefit_history: "Riwayat Konsultasi AI",
    membership_status_member: "Member",
  },
  fr: {
    membership_eyebrow: "ADHÉSION",
    membership_title: "L'accès aux adhésions est en cours de configuration.",
    membership_body:
      "L'adhésion donnera accès à l'écosystème d'intelligence olfactive PERSONA, incluant PERSONA AI PERFUMER et IPTECHS Academy.",
    membership_benefit_ai: "PERSONA AI PERFUMER",
    membership_benefit_academy: "IPTECHS ACADEMY",
    membership_benefit_profile: "AI Fragrance Profile",
    membership_benefit_history: "Historique de consultation IA",
    membership_status_member: "Member",
  },
};

export default P23;
